<section>
  <img src="assets/imgs/on-boarding/welcome.png" alt="Welcome background" />
  <img class="logo" src="assets/imgs/on-boarding/colored_logo.svg" alt="Mercadona colored logo" />
  <h1>{{ 'ON_BOARDING.TITLE' | translate }}</h1>
  <p>{{ 'ON_BOARDING.SUBTITLE_1' | translate }}</p>
  <p>{{ 'ON_BOARDING.SUBTITLE_2' | translate }}</p>
  <button class="c-button primary" (click)="onBeginClick()">{{ 'ON_BOARDING.BEGIN!' | translate }}</button>
</section>
